import { render, staticRenderFns } from "./AuthenticatedLayout.vue?vue&type=template&id=6b874b88&scoped=true&"
import script from "./AuthenticatedLayout.vue?vue&type=script&lang=ts&"
export * from "./AuthenticatedLayout.vue?vue&type=script&lang=ts&"
import style0 from "./AuthenticatedLayout.vue?vue&type=style&index=0&id=6b874b88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b874b88",
  null
  
)

export default component.exports